import { render, staticRenderFns } from "./ExamReport.vue?vue&type=template&id=1d63c7b2"
import script from "./ExamReport.vue?vue&type=script&lang=js"
export * from "./ExamReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports